import React, { useContext } from "react";
import { IconButton } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { theme } from "../theme";
import useWindowDimensions from "./hooks/useWindowDimensions";
import ListenerContext from "../listener/context";
import {
    openDisputChatView,
    openJobChatView,
    openOfficeChatView,
} from "../App/service";
import ChatOptionForm from "./chatOptionForm";
import OffcanvasTemplate from "./offcanvasTemplate";

const ChatOptionItem = ({ icon, label, handleClose, submitFunction }) => (
    <div className="d-flex mt-4">
        <div>
            <div
                className={`icon icon-shape bg-gradient-${theme.main} icon-md text-center border-radius-md shadow-none`}
                style={{
                    width: "48px",
                    height: "70px",
                }}
            >
                <i className="material-symbols-rounded text-white opacity-10" aria-hidden="true">
                    {icon}
                </i>
            </div>
        </div>
        <div className="ms-3">
            <div className="numbers">
                <h6 className="mb-1 text-dark text-sm">{label}</h6>
                <div className="mb-1 text-dark text-sm">
                    <ChatOptionForm handleClose={handleClose} submitFunction={submitFunction} />
                </div>
            </div>
        </div>
    </div>
);

const ChatOption = ({ show, handleClose }) => {
    const listener = useContext(ListenerContext);
    const { width } = useWindowDimensions();

    return (
        <OffcanvasTemplate
            open={show}
            handleClose={handleClose}
            placement="end"
            style={{
                top: "30%",
                bottom: width > 1320 ? "10%" : "16%",
                borderRadius: "10px",
                right: "2%",
            }}
            title="LIVE CHATS"
            body={
                <>
                    {width > 1320 && (
                        <img
                            className="rounded mx-auto d-block"
                            src="/assets/img/chat.png"
                            alt="tools"
                            style={{
                                width: "35%",
                                marginTop: "-10px",
                                marginBottom: "20px",
                            }}
                        />
                    )}

                    <div className="card">
                        <div className="card-body border-radius-lg p-3">
                            <ChatOptionItem
                                icon="work"
                                label="OPEN JOB CHAT"
                                handleClose={handleClose}
                                submitFunction={openJobChatView}
                            />

                            <ChatOptionItem
                                icon="mood_bad"
                                label="OPEN DISPUTE CHAT"
                                handleClose={handleClose}
                                submitFunction={openDisputChatView}
                            />

                            <div className="d-flex mt-4">
                                <div>
                                    <div
                                        className={`icon icon-shape bg-gradient-${theme.main} icon-md text-center border-radius-md shadow-none`}
                                    >
                                        <i className="material-symbols-rounded text-white opacity-10" aria-hidden="true">
                                            message
                                        </i>
                                    </div>
                                </div>
                                <div className="ms-3">
                                    <div className="numbers">
                                        <h6 className="mb-1 text-dark text-sm">OPEN OFFICE CHAT</h6>
                                        <span className="text-sm">You can open an office chat</span>
                                    </div>
                                </div>
                                <div className="d-flex text-end" style={{ marginLeft: "50px" }}>
                                    <IconButton
                                        edge="end"
                                        color={theme.main}
                                        style={{ backgroundColor: "transparent" }}
                                        onClick={() => {
                                            handleClose();
                                            openOfficeChatView(listener.dispatch);
                                        }}
                                    >
                                        <ArrowForward sx={{ fontSize: "24px" }} />
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        />
    );
};

export default ChatOption;